module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content-header",
    staticStyle: {
      "height": "50px",
      "padding-bottom": "80px"
    }
  }, [_c('h1', {
    staticStyle: {
      "float": "left",
      "padding-right": "10px"
    }
  }, [_vm._v(_vm._s(_vm.$root.title))]), _vm._v(" "), (_vm.$root.device.isMobile) ? _c('span', {
    staticStyle: {
      "display": "block",
      "font-weight": "bold"
    }
  }, [_c('br'), _vm._v("\n      " + _vm._s(_vm.selectedVersion ? _vm.$root.shortText(_vm.selectedVersion.Name, 40) : '') + "\n      "), _c('br')]) : _c('h1', {
    staticStyle: {
      "float": "left",
      "word-wrap": "break-word",
      "padding-right": "10px",
      "background-color": "#ddd"
    }
  }, [_vm._v(_vm._s(_vm.selectedVersion ? _vm.$root.shortText(_vm.selectedVersion.Name, 26) : ''))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "padding": "0px 10px"
    }
  }, [_c('ul', {
    staticClass: "pagination pagination-sm inline",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [(_vm.$root.isAdmin) ? _c('li', [_c('a', {
    staticStyle: {
      "width": "120px!important",
      "text-align": "center"
    }
  }, [_c('label', {
    staticStyle: {
      "margin": "0px",
      "border": "none"
    },
    attrs: {
      "action": "#",
      "method": "get"
    },
    on: {
      "click": _vm.updateWebVersion
    }
  }, [_vm._m(0)])])]) : _vm._e(), _vm._v(" "), (_vm.$root.isAdmin) ? _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showProgress),
      expression: "!showProgress"
    }]
  }, [_c('a', {
    staticStyle: {
      "width": "150px!important",
      "text-align": "center"
    }
  }, [_c('label', {
    staticStyle: {
      "margin": "0px",
      "border": "none"
    },
    attrs: {
      "action": "#",
      "method": "get"
    }
  }, [_c('div', {
    staticClass: "input-group btnUpload",
    staticStyle: {
      "padding": "5px 10px",
      "color": "red"
    }
  }, [_c('span', {
    staticClass: "btnUpload"
  }, [_vm._v("Upload Updates (for LAN Printers)")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.uploadUpdateLAN
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.$root.isAdmin) ? _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showProgress),
      expression: "!showProgress"
    }]
  }, [_c('a', {
    staticStyle: {
      "width": "150px!important",
      "text-align": "center"
    }
  }, [_c('label', {
    staticStyle: {
      "margin": "0px",
      "border": "none"
    },
    attrs: {
      "action": "#",
      "method": "get"
    }
  }, [_c('div', {
    staticClass: "input-group btnUpload",
    staticStyle: {
      "padding": "5px 10px",
      "color": "red"
    }
  }, [_c('span', {
    staticClass: "btnUpload"
  }, [_vm._v("Upload Updates (for USB Printers)")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.uploadUpdateUSB
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.$root.isAdmin) ? _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showProgress),
      expression: "!showProgress"
    }]
  }, [_c('a', {
    staticStyle: {
      "width": "150px!important",
      "text-align": "center"
    }
  }, [_c('label', {
    staticStyle: {
      "margin": "0px",
      "border": "none"
    },
    attrs: {
      "action": "#",
      "method": "get"
    }
  }, [_c('div', {
    staticClass: "input-group btnUpload",
    staticStyle: {
      "padding": "5px 10px",
      "color": "red"
    }
  }, [_c('span', {
    staticClass: "btnUpload"
  }, [_vm._v("Upload Installer (for LAN Printers)")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.uploadInstallerLAN
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.$root.isAdmin) ? _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showProgress),
      expression: "!showProgress"
    }]
  }, [_c('a', {
    staticStyle: {
      "width": "150px!important",
      "text-align": "center"
    }
  }, [_c('label', {
    staticStyle: {
      "margin": "0px",
      "border": "none"
    },
    attrs: {
      "action": "#",
      "method": "get"
    }
  }, [_c('div', {
    staticClass: "input-group btnUpload",
    staticStyle: {
      "padding": "5px 10px",
      "color": "red"
    }
  }, [_c('span', {
    staticClass: "btnUpload"
  }, [_vm._v("Upload Installer (for USB Printers)")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.uploadInstallerUSB
    }
  })])])])]) : _c('li', [(0 > 1) ? _c('a', {
    staticStyle: {
      "width": "150px!important",
      "text-align": "center"
    }
  }, [_c('label', {
    staticStyle: {
      "margin": "0px",
      "border": "none"
    },
    attrs: {
      "title": "Download [Printer Counters] installer latest version",
      "action": "#",
      "method": "get"
    },
    on: {
      "click": function($event) {
        return _vm.downloadClientLAN()
      }
    }
  }, [_vm._m(1)])]) : _vm._e(), _vm._v(" "), (0 > 1) ? _c('a', {
    staticStyle: {
      "width": "150px!important",
      "text-align": "center"
    }
  }, [_c('label', {
    staticStyle: {
      "margin": "0px",
      "border": "none"
    },
    attrs: {
      "title": "Download [Printer Counters] installer latest version",
      "action": "#",
      "method": "get"
    },
    on: {
      "click": function($event) {
        return _vm.downloadClientUSB()
      }
    }
  }, [_vm._m(2)])]) : _vm._e()]), _vm._v(" "), (_vm.$root.isAdmin) ? _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showProgress),
      expression: "showProgress"
    }]
  }, [_c('a', {
    staticStyle: {
      "width": "80px!important",
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "progress-group",
    staticStyle: {
      "float": "right",
      "margin": "0px",
      "width": "170px"
    }
  }, [_c('span', {
    staticClass: "progress-text"
  }, [_vm._v("Uploading ...")]), _vm._v(" "), _c('div', {
    staticClass: "progress sm"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-success",
    style: ({
      width: _vm.percent + '%'
    })
  })])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('row', [_c('column', {
    staticClass: "col-md-6"
  }, [_c('column', {
    staticClass: "col-md-12"
  }, [_c('va-box', {
    ref: "dealersBox",
    attrs: {
      "title": "Customers and Sites",
      "isBorder": true,
      "theme": "box-warning",
      "widgetType": "",
      "list": _vm.dealers
    },
    on: {
      "change": _vm.dealerChanged
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('h5', [_vm._v("Please select Site(s) to be updated:")]), _vm._v(" "), (!_vm.hasData && 0 > 1) ? _c('va-alert', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "warning"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('i', {
    staticClass: "icon fa fa-warning"
  }), _vm._v(" No Data Found !\n                  ")])]) : _vm._e(), _vm._v(" "), _c('tree', {
    key: _vm.selectedDealer,
    ref: "treeSites",
    staticClass: "tree--small",
    attrs: {
      "if": "!isLoadingTree",
      "data": _vm.treeSites,
      "options": {
        checkbox: true
      }
    },
    on: {
      "node:checked": _vm.siteChecked,
      "node:unchecked": _vm.siteUnchecked
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var node = ref.node;

        return _c('span', {
          staticClass: "tree-text"
        }, [
          [(node.data && node.data.isDealer) ? _c('i', {
            staticClass: "ion-bag"
          }) : _vm._e(), _vm._v(" "), (node.data && node.data.isCustomer) ? _c('i', {
            staticClass: "icon fa fa-user-o"
          }) : _vm._e(), _vm._v(" "), (node.data && node.data.isComputer && node.data.isUSB) ? _c('i', {
            staticClass: "icon fa fa-usb",
            attrs: {
              "title": "USB Client"
            }
          }) : _vm._e(), _vm._v(" "), (node.data && node.data.isComputer && !node.data.isUSB) ? _c('i', {
            staticClass: "icon fa fa-sitemap",
            attrs: {
              "title": "Network Client"
            }
          }) : _vm._e(), _vm._v("\n                      " + _vm._s(node.text) + "\n                      "), (node.data && node.data.isComputer) ? _c('small', {
            staticClass: "label label-default"
          }, [_vm._v(_vm._s(node.data.currentVersion))]) : _vm._e(), _vm._v(" "), (node.data && node.data.isComputer) ? _c('small', {
            staticClass: "label label-default"
          }, [_vm._v(_vm._s(node.data.siteKey))]) : _vm._e()]
        ], 2)
      }
    }])
  })], 1)])])], 1)], 1), _vm._v(" "), _c('column', {
    staticClass: "col-md-6"
  }, [_c('column', {
    staticClass: "col-md-12"
  }, [_c('va-box', {
    attrs: {
      "title": "Latest Versions (for LAN Printers)",
      "isBorder": true,
      "theme": "box-warning",
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('h5', [_vm._v("Please select LAN client version to be downloaded:")]), _vm._v(" "), _c('ul', _vm._l((_vm.versionsList), function(ver, index) {
    return (!ver.IsUSB) ? _c('li', {
      class: ['tree-node', ver.selected ? 'checked' : ''],
      on: {
        "click": function($event) {
          return _vm.selectVersion(ver['.key'])
        }
      }
    }, [_c('div', {
      staticClass: "tree-content tree--small"
    }, [_c('i', {
      class: ['tree-checkbox', ver.selected ? 'checked' : '']
    }), _vm._v(" "), _c('span', {
      staticClass: "tree-anchor",
      attrs: {
        "tabindex": "-1"
      }
    }, [_c('span', {
      staticClass: "tree-text",
      staticStyle: {
        "white-space": "normal"
      }
    }, [(!_vm.$root.device.isMobile) ? _c('i', {
      staticClass: "icon fa fa-windows"
    }) : _vm._e(), _vm._v(" " + _vm._s(_vm.$root.shortText(ver.Name, 40)) + "\n                        "), (!_vm.$root.device.isMobile) ? _c('small', {
      staticClass: "label label-default"
    }, [_c('i', {
      staticClass: "fa fa-clock-o"
    }), _vm._v(" " + _vm._s(ver.Date))]) : _vm._e(), _vm._v(" "), (!_vm.$root.device.isMobile) ? _c('small', {
      staticClass: "label label-default"
    }, [_vm._v(" " + _vm._s(ver['.key']))]) : _vm._e()])]), _vm._v(" "), (_vm.$root.isAdmin && !_vm.$root.device.isMobile) ? _c('div', {
      staticClass: "tools"
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      on: {
        "click": function($event) {
          return _vm.confirmDelete(ver)
        }
      }
    })]) : _vm._e()])]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('va-button', {
    attrs: {
      "isBlock": false,
      "theme": "danger",
      "name": "Cancel",
      "align": "right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    }
  }), _vm._v(" "), _c('va-button', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "isBlock": false,
      "theme": "success",
      "name": "Update",
      "align": "right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateLAN($event)
      }
    }
  })], 1)])], 1), _vm._v(" "), _c('column', {
    staticClass: "col-md-12"
  }, [_c('va-box', {
    attrs: {
      "title": "Latest Versions (for USB Printers)",
      "isBorder": true,
      "theme": "box-warning",
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('h5', [_vm._v("Please select USB client version to be downloaded:")]), _vm._v(" "), _c('ul', _vm._l((_vm.versionsList), function(ver, index) {
    return (ver.IsUSB) ? _c('li', {
      class: ['tree-node', ver.selected ? 'checked' : ''],
      on: {
        "click": function($event) {
          return _vm.selectVersion(ver['.key'])
        }
      }
    }, [_c('div', {
      staticClass: "tree-content tree--small"
    }, [_c('i', {
      class: ['tree-checkbox', ver.selected ? 'checked' : '']
    }), _vm._v(" "), _c('span', {
      staticClass: "tree-anchor",
      attrs: {
        "tabindex": "-1"
      }
    }, [_c('span', {
      staticClass: "tree-text",
      staticStyle: {
        "white-space": "normal"
      }
    }, [(!_vm.$root.device.isMobile) ? _c('i', {
      staticClass: "icon fa fa-windows"
    }) : _vm._e(), _vm._v(" " + _vm._s(_vm.$root.shortText(ver.Name, 40)) + "\n                        "), (!_vm.$root.device.isMobile) ? _c('small', {
      staticClass: "label label-default"
    }, [_c('i', {
      staticClass: "fa fa-clock-o"
    }), _vm._v(" " + _vm._s(ver.Date))]) : _vm._e(), _vm._v(" "), (!_vm.$root.device.isMobile) ? _c('small', {
      staticClass: "label label-default"
    }, [_vm._v(" " + _vm._s(ver['.key']))]) : _vm._e()])]), _vm._v(" "), (_vm.$root.isAdmin && !_vm.$root.device.isMobile) ? _c('div', {
      staticClass: "tools"
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      on: {
        "click": function($event) {
          return _vm.confirmDelete(ver)
        }
      }
    })]) : _vm._e()])]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('va-button', {
    attrs: {
      "isBlock": false,
      "theme": "danger",
      "name": "Cancel",
      "align": "right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    }
  }), _vm._v(" "), _c('va-button', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "isBlock": false,
      "theme": "success",
      "name": "Update",
      "align": "right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateUSB($event)
      }
    }
  })], 1)])], 1)], 1)], 1)], 1), _vm._v(" "), _c('va-modal')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group btnUpload",
    staticStyle: {
      "padding": "5px 10px",
      "color": "green"
    }
  }, [_c('span', {
    staticClass: "btnUpload"
  }, [_vm._v("Update Web Version")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group btnUpload",
    staticStyle: {
      "padding": "5px 10px",
      "color": "green"
    }
  }, [_c('span', {
    staticClass: "btnUpload"
  }, [_vm._v("Download LAN Client Installer")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group btnUpload",
    staticStyle: {
      "padding": "5px 10px",
      "color": "green"
    }
  }, [_c('span', {
    staticClass: "btnUpload"
  }, [_vm._v("Download USB Client Installer")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5cdd101e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Updates.vue
// module id = 713
// module chunks = 0